import type { ComputedRoute, RouteDetails } from '../types/api';
import { ROUTE_COLORS } from '../types/api';

interface RouteCardProps {
  route: ComputedRoute;
  index: number;
  selected: boolean;
  onSelect: (index: number) => void;
}

export function RouteCard({ route, index, selected, onSelect }: RouteCardProps) {
  const color = ROUTE_COLORS[route.label] || '#aaa';
  const stats = route.stats;
  const details = route.details;

  const formatDist = (m: number) => (m / 1609.344).toFixed(2) + ' mi';
  const formatElev = (m: number) => (m * 3.28084).toFixed(0) + ' ft';
  const formatGrade = (pct: number) => pct.toFixed(1) + '%';

  return (
    <div
      className={`route-card ${selected ? 'selected' : ''}`}
      onClick={() => onSelect(index)}
    >
      <h3>
        <span className="route-badge" style={{ background: color }} />
        {route.label.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())}
      </h3>

      <div className="route-stats">
        <div>Distance: <span className="stat-value">{formatDist(stats.distance_m)}</span></div>
        <div>Gain: <span className="stat-value">{formatElev(stats.elevation_gain_m)}</span></div>
        <div>Max Grade: <span className="stat-value">{formatGrade(stats.max_grade_pct)}</span></div>
        <div>Avg Climb: <span className="stat-value">{formatGrade(stats.avg_grade_pct)}</span></div>
        <div>Safety: <span className="stat-value">{stats.safety_score.toFixed(0)}/100</span></div>
      </div>

      {selected && (
        <div className="cost-breakdown">
          <DetailRow label="Hard Climb" value={formatElev(details.climb_m)} color="#e94560" />
          <DetailRow label="Bike Infra" value={details.bike_infra_pct.toFixed(0) + '% of route'} color="#6bcb77" />
          {details.contraflow_m > 0 && (
            <DetailRow label="Contraflow" value={formatElev(details.contraflow_m)} color="#ffd93d" />
          )}
          {details.rough_surface_m > 0 && (
            <DetailRow label="Rough Surface" value={formatDist(details.rough_surface_m)} color="#ff6b6b" />
          )}
          {details.busy_roads_m > 0 && (
            <DetailRow label="Busy Roads" value={formatDist(details.busy_roads_m)} color="#45b7d1" />
          )}
        </div>
      )}
    </div>
  );
}

function DetailRow({ label, value, color }: { label: string; value: string; color: string }) {
  return (
    <div className="cost-bar">
      <span className="cost-bar-label" style={{ color }}>{label}</span>
      <span className="cost-bar-value">{value}</span>
    </div>
  );
}
